/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { OverlayModal } from '@components/OverlayModal/OverlayModal';

export namespace DisableIEMode {
  export interface Props {}
}

export const DisableIEMode: React.FC<DisableIEMode.Props> = ({}) => {
  const isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g);

  return (
    <OverlayModal
      data-it="DisableIEMode-Modal"
      isOpen={isIE}
      header={'Oops, you need a different browser.'}
      subHeader={
        'Blend Signing Room is not optimized for Internet Explorer. Please use Google Chrome, Safari, Firefox, or Microsoft Edge to continue.'
      }
      contentLabel={'IE Disabled'}
    />
  );
};
